import gql from "graphql-tag";

export const MY_HR_GET_USER_BY_EMPLOYEE = gql`
  query userByEmployee($employee: String!) {
    userByEmployee(employee: $employee) {
      _id
      employee
      email
      phone
      ldapUser
      lastLogin
      lastPasswordChange
      validFrom
      validTo
      twoFactorEnabled
      twoFactorEnabledAt
      twoFactorType
      twoFactorFailedCode
      modifiedAt
    }
  }
`;
